export class CompensationDateInputModel {
  fromMonth: number
  fromYear: number
  toMonth: number
  toYear: number
  totalHoursTransferred: number
}
